import { render, staticRenderFns } from "./IcoolStatus.vue?vue&type=template&id=0bfb7c9a&scoped=true&"
import script from "./IcoolStatus.vue?vue&type=script&lang=js&"
export * from "./IcoolStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb7c9a",
  null
  
)

export default component.exports